import type { RouteRecordRaw } from "vue-router";
import UserList from "@/views/UserList.vue";
import { set_default_pagination } from "./util";

export const userRoutes: RouteRecordRaw = {
  path: "/user",
  children: [
    {
      path: "",
      component: UserList,
      name: "UserList",
      beforeEnter: set_default_pagination,
    },
  ],
};
